import { forwardRef, useEffect } from 'react';

//zip : using 3d viewer code.
import * as OV from 'online-3d-viewer';

const Model3DLoaderLib = forwardRef((props, ref) => {
  if (!props?.url || !props?.extension) return null;
  return <Load3DModel {...props} ref={ref} />;
});

export default Model3DLoaderLib;

const Load3DModel = forwardRef(({ url, file, extension, setModelLoading }, ref) => {

  useEffect(() => {
    console.log('file data', file);
   
    const viewer = new OV.EmbeddedViewer(ref?.current, {
   
      // backgroundColor: new OV.RGBAColor(255, 255, 255, 255),
      // defaultColor: new OV.RGBColor(200, 200, 200),
      // edgeSettings: new OV.EdgeSettings(false, new OV.RGBColor(0, 0, 0), 1),
      // environmentSettings: new OV.EnvironmentSettings(
      //   [
      //     'assets/envmaps/fishermans_bastion/posx.jpg',
      //     'assets/envmaps/fishermans_bastion/negx.jpg',
      //     'assets/envmaps/fishermans_bastion/posy.jpg',
      //     'assets/envmaps/fishermans_bastion/negy.jpg',
      //     'assets/envmaps/fishermans_bastion/posz.jpg',
      //     'assets/envmaps/fishermans_bastion/negz.jpg',
      //   ],
      //   false
      // ),
      backgroundColor: new OV.RGBAColor(255, 255, 255, 255),
      defaultColor: new OV.RGBColor(200, 200, 200),
      edgeSettings: new OV.EdgeSettings(false, new OV.RGBColor(0, 0, 0), 1),
      environmentSettings: new OV.EnvironmentSettings(
        [
          '/envmap/fishermans_bastion/posx.jpg',
          '/envmap/fishermans_bastion/negx.jpg',
          '/envmap/fishermans_bastion/posy.jpg',
          '/envmap/fishermans_bastion/negy.jpg',
          '/envmap/fishermans_bastion/posz.jpg',
          '/envmap/fishermans_bastion/negz.jpg',
        ],
        false
      ),
    });

   
    if (file.file.blobUrl) {
      
      fetch(file.file.blobUrl)
        .then((r) => r.blob())
        .then((blobdata) => {
          console.log("after loading");
          viewer.LoadModelFromFileList([new File([blobdata], 'file.'+extension)]);
        });
    } 
    else 
    {
      // viewer.LoadModelFromFileList([file.file]); // for device storage
      // console.log("before loading_________________2");
      fetch(file.url)
      .then((r) => r.blob())
      .then((blobdata) => {
        viewer.LoadModelFromFileList([new File([blobdata], 'file.'+extension)]);
      });
    }

    return () => {
      
      // const viewerElement = document.querySelector('#viewer');
      // if (ref?.current /*&& viewerElement*/) ref?.current?.remove();
      while (ref?.current && ref?.current.firstChild) { 
        // element.removeChild(element.firstChild); 
        // OR 
        ref?.current.firstChild.remove(); 
    }
      viewer.Destroy();
      
    };
  }, [url, extension, ref]);

  return <div ref={ref} style={{ width: '100%', height: '100%' }} />;
});